import { Autocomplete, Box, Button, Dialog, FormControlLabel, Grid, IconButton, InputAdornment, Radio, RadioGroup, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../Styles/Colors'
import ToastMsg from '../../Components/ToastMsg/ToastMsg'
import { DataGrid } from '@mui/x-data-grid'
import { CommonGridToolBarWithFilterTextCustom } from '../../Components/Common Components/CommonComponents'
import { ImagePaths } from '../../Utility/ImagePaths'
import WarningIcon from '@mui/icons-material/Warning';
import RestAPIService from '../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../Utility/API/Serviceurls'
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CommonValidation from '../../Components/CommonFunctions/CommonValidation'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import EditIcon from '@mui/icons-material/Edit';
import Loader from '../../Components/Loader';
import { formatDate, formatDateTime, passwordValidations } from '../../Components/CommonFunctions/CommonFunctions'

const NurseLogin = () => {
    const [selectedRoleId, setSelectedRoleId] = useState('');
    const [postLoad, setPostLoad] = useState(false)
    const [states, setStates] = useState({
        nurseLoginData: [],
        page: 0,
        pageSize: 10,
        isLoader: false,
        addNewUser: false,
        specializationSugg: [],
        selectedSpecial: null,
        selectedSpecialId: null,
        loginName: '',
        emailId: '',
        phoneNo: '',
        password: '',
        confirmPassword: '',
        selectedBranch: null,
        selectedBranchId: null,
        selectedRemainCount: null,
        selectedMaxCount: null,
        branchSugg: [],
        selectedNurse: null,
        selectedNurseId: null,
        nurseSugg: [],
        multiDataActInactive: [],
        showPassword: false,
        showConfirmPassword: false,
        isEdit: false,
        selectedId: null,
        // roleList: [],
        SelectedPassType: "strong",
    })
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: message
        })
        setPostLoad(false)
    }

    const successMessage = (message) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: message,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    // API STARTS ===========>

    useEffect(() => {
        getNurseLoginData()
        // getUserRoleList()
    }, [])

    useEffect(() => {
        if(states?.isEdit && states.branchSugg.length > 0 && states.selectedBranchId && states.selectedBranchId !== ''){
            const branchDetail = states.branchSugg.find(branch => branch.id === states.selectedBranchId);
            if (branchDetail) {
                setStates((prev) => ({
                    ...prev,
                    selectedMaxCount: branchDetail.max_nurse_login_count,
                    selectedRemainCount: branchDetail.remaining_nurse_login_count,
                    SelectedPassType: branchDetail.password_type
                }));
            }
        }
    },[states?.isEdit, states.branchSugg, states.selectedBranchId])

    // const getUserRoleList = () => {
    //     try {
    //         // Assuming you have a specific role endpoint for nurses or use the same
    //         RestAPIService.getAll(Serviceurls.SUPER_ADMIN_LOGIN_ROLE)
    //             .then((response) => {
    //                 if (response.data?.status === 'success') {
    //                     setStates((prev) => ({ ...prev, roleList: response?.data?.data }))
    //                 }
    //             }).catch((error) => {
    //                 if (error?.response?.data?.message) {
    //                     errorMessage(error?.response?.data?.message)
    //                 } else {
    //                     errorMessage(error.message)
    //                 }
    //             })
    //     } catch (error) {
    //         errorMessage(error.message)
    //     }
    // }

    const getBranchListData = (isEdit = false) => {
        try {
            setStates((prev) => ({ ...prev, isLoader: true, postLoad: true }))
            RestAPIService.getAll(Serviceurls.SUPER_ADMIN_BRANCH_LIST)
                .then((response) => {
                    if (response.data?.status === 'success') {
                        if (!isEdit) {
                            setStates((prev) => ({
                                ...prev,
                                branchSugg: response?.data?.data,
                                selectedBranch: response?.data?.data[0]?.branch_name,
                                selectedBranchId: response?.data?.data[0]?.id,
                                selectedRemainCount: response?.data?.data[0]?.remaining_nurse_login_count, 
                                selectedMaxCount: response?.data?.data[0]?.max_nurse_login_count, 
                                SelectedPassType: response?.data?.data[0]?.password_type,
                                isLoader: false, postLoad: false
                            }))
                            getNurseListData(response?.data?.data[0]?.id)
                        }
                        else{
                            setStates((prev) => ({
                                ...prev,
                                branchSugg: response?.data?.data,
                                isLoader: false, postLoad: false
                            }))
                        }
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getNurseListData = (branchId, isEdit = false) => {
        try {
            setPostLoad(true)
            RestAPIService.getAll(Serviceurls.SUPER_ADMIN_NURSE_LIST + '?branch_id=' + branchId)
                .then((response) => {
                    if (response.data?.status === 'success') {
                        setStates((prev) => ({ ...prev, nurseSugg: response?.data?.data, isLoader: false }))
                        if (isEdit === false) {
                            setStates((prev) => ({ ...prev, selectedNurse: null, selectedNurseId: null }))
                        }
                        setPostLoad(false)
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getNurseLoginData = () => {
        try {
            setPostLoad(true)
            RestAPIService.getAll(Serviceurls.SUPER_ADMIN_NURSE_LOGIN)
                .then((response) => {
                    if (response.data?.status === 'success') {
                        setStates((prev) => ({ ...prev, nurseLoginData: response?.data?.data, isLoader: false }))
                        setPostLoad(false)
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const postNurseLoginData = () => {
        try {
            setPostLoad(true)
            var passWord = passwordValidations(states.password, states?.SelectedPassType)
            let data = {
                id: states.selectedId ? states.selectedId : null,
                branch_id: states.selectedBranchId,
                nurse_id: states.selectedNurseId,
                login_name: states.loginName,
                // login_role_id: selectedRoleId,
                login_email_address: states.emailId,
                login_phone_number: states.phoneNo,
                login_password: states.password === '' ? 'None' : states.password
            }
            if(states.isEdit && (states.phoneNo === '' || states.phoneNo.length < 10)){
                errorMessage('Enter Phone Number')
                return
            }
            if (states.isEdit && states.password !== '' && states.confirmPassword === '') {
                errorMessage('Enter Confirm Password')
                return
            }

            if (states.isEdit && states.password !== '' && states.password !== states.confirmPassword) {
                errorMessage(`Confirm Password doesn't match with Password`)
                return
            }

            if (states.loginName === '') {
                errorMessage('Enter Login Name')
            } else if (!states.isEdit && (states.phoneNo === '' || states.phoneNo.length < 10)) {
                errorMessage('Enter Phone Number')
            } else if (!states.isEdit && (states.password === '' || states.confirmPassword === '')) {
                errorMessage('Enter Password')
            } else if (!states.isEdit && (states.password !== states.confirmPassword)) {
                errorMessage(`Confirm Password doesn't match with Password`)
            } else if (states.selectedBranch === null) {
                errorMessage('Select Branch')
            } else if (states.selectedNurse === null) {
                errorMessage('Select Nurse')
            } else if (states.emailId !== '' && !CommonValidation.emailValidation(states.emailId)) {
                errorMessage("Invalid E-Mail")
            } else if (states.password !== '' && passWord) {
                errorMessage(passWord)
            } else {
                RestAPIService.create(data, Serviceurls.SUPER_ADMIN_NURSE_LOGIN)
                    .then((response) => {
                        if (response.data?.status === 'success') {
                            successMessage(response?.data?.message)
                            setStates((prev) => ({ ...prev, addNewUser: false }))
                            setPostLoad(false)
                            getNurseLoginData()
                            onClearHandler()
                        }
                    }).catch((error) => {
                        if (error?.response?.data?.message) {
                            errorMessage(error?.response?.data?.message)
                        } else {
                            errorMessage(error.message)
                        }
                    })
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const putNurseLoginData = (ids, status = true) => {
        try {
            const userId = Array.isArray(ids) ? ids[0] : ids;
            const userData = states.nurseLoginData.find((item) => item.id === userId);
            const branchDetailId = userData?.branch_detail_id;
            let data = {
                id: ids,
                is_deactivated: status,
                branch_id: branchDetailId,
            }
            setPostLoad(true)
            RestAPIService.updateWithOutId(data, Serviceurls.SUPER_ADMIN_NURSE_LOGIN)
                .then((response) => {
                    if (response.data?.status === 'success') {
                        successMessage(response?.data?.message)
                        setStates((prev) => ({ ...prev, addNewUser: false, multiDataActInactive: [] }))
                        setPostLoad(false)
                        getNurseLoginData()
                        onClearHandler()
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    // API ENDS ============>

    const onChangeAutoHandler = (value, key) => {
        try {
            setStates((prev) => {
                switch (key) {
                    case 'selectedSpecial':
                        return { ...prev, selectedSpecial: value, selectedSpecialId: value?.id }
                    case 'selectedBranch':
                        if (value === null) {
                            return {
                                ...prev,
                                selectedBranch: null,
                                selectedBranchId: null,
                                selectedRemainCount: 10,
                                selectedMaxCount: 10,
                                SelectedPassType: "strong",
                                selectedNurse: null,
                                selectedNurseId: null,
                                nurseSugg: [] 
                            };
                        }
                        getNurseListData(value?.id)
                        return {
                            ...prev,
                            selectedBranch: value?.branch_name,
                            selectedBranchId: value?.id,
                            selectedRemainCount: value?.remaining_nurse_login_count,
                            selectedMaxCount: value?.max_nurse_login_count,
                            SelectedPassType: value?.password_type
                        };
                    case 'selectedNurse':
                        return { ...prev, selectedNurse: value, selectedNurseId: value?.nurse_id };
                    case 'loginName':
                        if (CommonValidation.alphabetOnly(value) || value === '') {
                            return { ...prev, loginName: value }
                        } else {
                            return { ...prev }
                        }
                    case 'emailId':
                        return { ...prev, emailId: value }
                    case 'phoneNo':
                        if (CommonValidation.numberOnly(value) && value?.length <= 10 || value === '') {
                            return { ...prev, phoneNo: value }
                        } else {
                            return { ...prev }
                        }
                    case 'password':
                        return { ...prev, password: value }
                    case 'confirmPassword':
                        return { ...prev, confirmPassword: value }
                    default: break;
                }
            })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const autoCompleteTextBox = (key, values, options, labels, width, optionKey) => {
        try {
            return (
                <Autocomplete
                    clearIcon
                    size='small'
                    sx={{ width: width ? width : '17dvw' }}
                    options={options}
                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option[optionKey]}
                    value={values}
                    onChange={(e, value) => onChangeAutoHandler(value, key)}
                    renderInput={(params) => <TextField
                        {...params}
                        InputProps={{ ...params.InputProps, emed_tid: key }}
                        label={labels}
                    />}
                />
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const textBox = (key, values, labels, width) => {
        try {
            return (
                <TextField
                    autoComplete={(key === 'password' || key === 'confirmPassword') ? 'new-password' : 'off'}
                    size='small'
                    sx={{ width: width ? width : '17dvw' }}
                    label={labels}
                    value={values}
                    inputProps={{ emed_tid: key }}
                    onChange={(e) => {
                        let value = e.target.value
                        onChangeAutoHandler(value, key)
                    }}
                    type={(key === 'password' && !states.showPassword) || (key === 'confirmPassword' && !states.showConfirmPassword) ? 'password' : 'text'}
                    InputProps={{
                        endAdornment: (key === 'password' || key === 'confirmPassword') ? (
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={() =>
                                        setStates((prev) => ({
                                            ...prev,
                                            ...(key === 'password'
                                                ? { showPassword: !prev.showPassword }
                                                : { showConfirmPassword: !prev.showConfirmPassword }),
                                        }))
                                    }
                                    edge="end"
                                >
                                    {(key === 'password' && states.showPassword) || (key === 'confirmPassword' && states.showConfirmPassword) ?
                                        (<VisibilityIcon />) : (<VisibilityOffIcon />)}
                                </IconButton>
                            </InputAdornment>
                        ) : null,
                    }}
                />
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    // const handleChange = (event) => {
    //     setSelectedRoleId(event.target.value);
    // };

    const onClearHandler = () => {
        try {
            setStates((prev) => ({
                ...prev,
                isLoader: false,
                addNewUser: false,
                selectedSpecial: null,
                selectedSpecialId: null,
                loginName: '',
                emailId: '',
                phoneNo: '',
                password: '',
                confirmPassword: '',
                selectedBranch: null,
                selectedBranchId: null,
                selectedNurse: null,
                selectedNurseId: null,
                multiDataActInactive: [],
                selectedMaxCount: 10,
                SelectedPassType: "strong",
                selectedRemainCount: 10,
                isEdit: false,
                selectedId: null
            }))
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const onEditHandler = (item) => {
        try {
            if (item?.branch_detail_id) {
                getNurseListData(item?.branch_detail_id, true)
                getBranchListData(true)
            }
            const branchDetail = states.branchSugg.find(branch => branch.id === item.branch_detail_id);
            setStates((prev) => ({
                ...prev,
                loginName: item?.login_name,
                phoneNo: item?.login_phone_number || '',
                emailId: item?.login_email_address || '',
                selectedBranch: item?.branch_name,
                selectedBranchId: item?.branch_detail_id,
                selectedNurse: item?.nurse,
                selectedNurseId: item?.nurse_id,
                selectedId: item?.id,
                selectedMaxCount: branchDetail?.max_nurse_login_count,
                selectedRemainCount: branchDetail?.remaining_nurse_login_count,
                selectedSpecial: item?.role_comments || null,
                // selectedSpecialId: item?.login_role_id || null,
                password: '',
                confirmPassword: '',
                addNewUser: true,
                isEdit: true,
            }))
            // setSelectedRoleId(item?.login_role_id)
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderAddNewUserPopup = () => {
        try {
            return (
                <Dialog open={states.addNewUser} fullWidth maxWidth="lg">
                    <Box className="com_billing_popup" height="70dvh">
                        <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                            <Typography fontSize={'1rem'} fontWeight={600}>{states.isEdit ? 'Update Nurse Login' : 'Add Nurse Login'}</Typography>
                            <IconButton onClick={() => { onClearHandler() }}>
                                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                            </IconButton>
                        </Box>

                        <Box component={'div'} p={'0.5rem 1.5rem'} borderBottom={'2px solid lightgray'}>
                            <Grid container>
                                <Grid item xs={12}>
                                    <Typography color={Colors.grayShade} gutterBottom>Hospital Details</Typography>
                                </Grid>

                                <Grid item xs={12} container spacing={2}>
                                    <Grid item md={3}>
                                        {autoCompleteTextBox('selectedBranch', states.selectedBranch, states.branchSugg, 'Select Branch *', '', 'branch_name')}
                                    </Grid>
                                    <Grid item display={"flex"} md={3}>
                                        {autoCompleteTextBox('selectedNurse', states.selectedNurse, states.nurseSugg, 'Select Nurse *', '', 'nurse_name')}
                                    </Grid>
                                    <Grid item display={"flex"} md={6}>
                                        {states?.selectedNurse ?
                                            <span className='' style={{ marginTop: "1dvh" }}>
                                                {`${states?.selectedNurse?.first_name || ''} ${states?.selectedNurse?.last_name || ''}`}
                                            </span>
                                            : null}
                                    </Grid>
                                </Grid>
                                {/* <Grid item xs={12}>
                                    <Typography color={Colors.grayShade} gutterBottom>Nurse Layout Type</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <RadioGroup
                                        value={selectedRoleId}
                                        sx={{ display: 'flex', flexDirection: 'row' }}
                                        onChange={(e) => handleChange(e)}
                                    >
                                        {states?.roleList?.map((role) => (
                                            <FormControlLabel
                                                key={role.id}
                                                value={role.id}
                                                control={<Radio size="small" />}
                                                label={role.role_comments}
                                            />
                                        ))}
                                    </RadioGroup>
                                </Grid> */}
                                <Grid item xs={12} marginTop={'.5vw'}>
                                    <Typography color={Colors.grayShade} gutterBottom>Basic Details</Typography>
                                </Grid>

                                <Grid item xs={12} container spacing={2}>
                                    <Grid item md={3}>
                                        {textBox('loginName', states.loginName, 'Login Name *')}
                                    </Grid>
                                    <Grid item md={3}>
                                        {textBox('emailId', states.emailId, 'Email ID')}
                                    </Grid>
                                    <Grid item md={3}>
                                        {textBox('phoneNo', states.phoneNo, 'Phone No *')}
                                    </Grid>
                                    <Grid item md={3}>
                                        {textBox('password', states.password, 'Password *')}
                                    </Grid>
                                    <Grid item md={3}>
                                        {textBox('confirmPassword', states.confirmPassword, 'Confirm Password *')}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box component={'div'}
                            height={'17dvh'} borderBottom={'2px solid lightgray'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                            <Box border={'2px solid #FFE6E6'} p={'0.5rem'} width={'22dvw'} display={'flex'} justifyContent={'center'} alignItems={'center'} sx={{ backgroundColor: '#FFE6E6' }}>
                                <Box><WarningIcon color='warning' sx={{ width: '2dvw', height: '2dvw', mr: '0.5rem' }} /></Box>
                                <Box component={'div'}>
                                    <Typography fontSize={'0.9rem'} fontWeight={600}>{states.selectedRemainCount === 0 ? `You have reached your ${states.selectedMaxCount} Nurses Limit in ${states.selectedBranch}` : `You only have space for ${states.selectedRemainCount} more nurse in ${states.selectedBranch}`}</Typography>
                                    <Typography fontSize={'0.8rem'}>To get more,Contact <Box component={'a'} rel="noopener noreferrer" target='_blank' href='https://emedhub.in/contact-us/' fontSize={'0.8rem'}>eMedHub Support Team</Box></Typography>
                                </Box>
                            </Box>
                        </Box>

                        <Box component={'div'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} p={'0.5rem'}>
                            <Button variant="outlined" sx={{ textTransform: 'capitalize', mr: '1rem', height: '4.5dvh' }} onClick={() => onClearHandler()}>
                                Cancel
                            </Button>
                            <Button variant="contained" sx={{ textTransform: 'capitalize', height: '4.5dvh' }}
                                disabled={postLoad}
                                onClick={() =>
                                    postNurseLoginData()
                                }>
                                {states.isEdit ? 'Update' : 'Add User'}
                            </Button>
                        </Box>
                    </Box>
                </Dialog>
            );
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const gridToolBar = () => {
        var ExportData = []
        states.nurseLoginData?.length > 0 && states.nurseLoginData.map((item) =>
            ExportData.push({ 
                'Date&Time': item.created_date, 
                'Login Name': item.login_name, 
                'Phone No': item.login_phone_number, 
                'Email Id': item.login_email_address, 
                'Branch': item.branch_name, 
                'Nurse': item.nurse_name, 
                'Status': item.is_deactivated ? "InActive" : "Active" 
            })
        )
        return (
            <Box>
                <Box visibility={states.multiDataActInactive?.length !== 0 ? 'visible' : 'hidden'} sx={{ position: 'absolute', left: '0', top: '0', display: 'flex', flexDirection: 'row', alignItems: 'center', mt: '0.2vw', ml: '0.25vw' }}>
                    <Button variant='contained' color='error'
                        sx={{ textTransform: 'capitalize', height: '4.5dvh' }}
                        disabled={postLoad}
                        onClick={() => putNurseLoginData(states.multiDataActInactive, true)}
                    >Inactive</Button>
                </Box>
                <Box><CommonGridToolBarWithFilterTextCustom data={ExportData} title={"NurseUser"} filename={"NurseUser"} /></Box>
            </Box>

        )
    }

    const renderTable = () => {
        try {
            states.nurseLoginData?.forEach((element, index) => element.sno = index + 1)
            const columns = [
                {
                    field: 'created_date', headerName: 'Date & Time', flex: 0.15,
                    renderCell: (params) => {
                        return (
                            <Box>{params?.row?.created_date ? params?.row?.created_date : '-'}</Box>
                        )
                    }
                },
                {
                    field: 'login_name', headerName: 'Login Name', flex: 0.125,
                    renderCell: (params) => {
                        let loginName = params?.row?.login_name
                        return (
                            <Box>
                                {loginName ? loginName?.length > 15 ?
                                    <Tooltip placement='top' title={loginName}><Typography>{loginName?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                    <Typography>{loginName}</Typography> : '-'}
                            </Box>
                        )
                    }
                },
                {
                    field: 'login_phone_number', headerName: 'Phone No', flex: 0.1,
                    renderCell: (params) => {
                        let login_phone_number = params?.row?.login_phone_number
                        return (
                            <Box>
                                {login_phone_number ? login_phone_number?.length > 15 ?
                                    <Tooltip placement='top' title={login_phone_number}><Typography>{login_phone_number?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                    <Typography>{login_phone_number}</Typography> : '-'}
                            </Box>
                        )
                    }
                },
                {
                    field: 'login_email_address', headerName: 'Email ID', flex: 0.125,
                    renderCell: (params) => {
                        let login_email_address = params?.row?.login_email_address
                        return (
                            <Box>
                                {login_email_address ? login_email_address?.length > 15 ?
                                    <Tooltip placement='top' title={login_email_address}><Typography>{login_email_address?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                    <Typography>{login_email_address}</Typography> : '-'}
                            </Box>
                        )
                    }
                },
                {
                    field: 'branch_name', headerName: 'Branch', flex: 0.3,
                    renderCell: (params) => {
                        let branch_name = params?.row?.branch_name
                        return (
                            <Box>
                                {branch_name ? branch_name?.length > 16 ?
                                    <Tooltip placement='top' title={branch_name}><Typography>{branch_name?.slice(0, 40) + '...'}</Typography></Tooltip> :
                                    <Typography>{branch_name}</Typography> : '-'}
                            </Box>
                        )
                    }
                },
                {
                    field: 'nurse_name', headerName: 'Nurse', flex: 0.125,
                    renderCell: (params) => {
                        let nurse_name = params?.row?.nurse_name
                        return (
                            <Box>
                                {nurse_name ? nurse_name?.length > 15 ?
                                    <Tooltip placement='top' title={nurse_name}><Typography>{nurse_name?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                    <Typography>{nurse_name}</Typography> : '-'}
                            </Box>
                        )
                    }
                },
                {
                    field: 'is_deactivated', headerName: 'Status', flex: 0.06,
                    renderCell: (params) => {
                        let status = params?.row?.is_deactivated ? 'Inactive' : 'Active'
                        return (
                            <Box component={'div'}>{status}</Box>
                        )
                    }
                },
                {
                    field: 'action', headerName: 'Action', flex: 0.125, align: 'center', headerAlign: 'center',
                    renderCell: (params) => {
                        let label = params?.row?.is_deactivated ? 'Active' : 'Inactive'
                        let stats = label === 'Active' ? false : true
                        return (
                            <Box>
                                <IconButton sx={{ height: '2dvw', width: '2dvw' }}
                                    onClick={() => {onEditHandler(params?.row);}}
                                ><EditIcon color='primary' sx={{ height: '1.8dvw', width: '1.8dvw' }} /></IconButton>
                                <Tooltip placement='top' title={label} arrow>
                                    <IconButton sx={{ height: '2dvw', width: '2dvw' }}
                                        disabled={postLoad}
                                        onClick={() =>
                                            putNurseLoginData([params?.row?.id], stats)
                                        }
                                    >
                                        {label === 'Inactive' ? <CancelIcon color='error' sx={{ height: '1.8dvw', width: '1.8dvw' }} /> : <CheckCircleIcon color='primary' sx={{ height: '1.8dvw', width: '1.8dvw' }} />}
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        )
                    }
                },
            ]
            return (
                <Box component={'div'} sx={{ height: '70dvh' }}>
                    <DataGrid
                        checkboxSelection
                        isRowSelectable={(params) => !params.row.is_deactivated}
                        onSelectionModelChange={(id) => {
                            let selectedIDs = new Set(id);
                            let selectedRows = states.nurseLoginData?.filter((row) => selectedIDs.has(row.sno));
                            let ids = [];
                            selectedRows.forEach((item) => {
                                if (item.id) ids?.push(item?.id);
                            });
                            setStates((prev) => ({ ...prev, multiDataActInactive: ids }))
                        }}
                        rows={states.nurseLoginData}
                        page={states.page}
                        columns={columns}
                        hideFooterSelectedRowCount
                        getRowId={(row) => row.sno}
                        pageSize={states.pageSize}
                        onPageChange={(newPage) => { setStates((prev) => ({ ...prev, page: newPage })) }}
                        onPageSizeChange={(newPageSize) => { setStates((prev) => ({ ...prev, pageSize: newPageSize })) }}
                        rowsPerPageOptions={[10, 20, 30]}
                        loading={postLoad}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: gridToolBar,
                            NoRowsOverlay: () => (
                                <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100%'}>
                                    {'No Records To Be Shown'}
                                </Box>
                            )
                        }}
                        headerHeight={40}
                        disableSelectionOnClick
                    />
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    return (
        <Box component={'div'} sx={{ backgroundColor: Colors.Background, height: '80dvh' }}>
            <Box component={'div'} p={'0.5rem'}>
                <Grid container rowGap={1}>
                    <Grid xs={12}>
                        <Box component={'div'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                            <Button variant='contained'
                                sx={{ textTransform: 'capitalize', width: '10dvw' }}
                                onClick={() => {
                                    getBranchListData()
                                    setStates((prev) => ({ ...prev, addNewUser: true }))
                                }}
                            >Add user</Button>
                        </Box>
                    </Grid>
                    <Grid xs={12}>
                        <Box component={'div'} sx={{ backgroundColor: Colors.white, height: '72dvh' }}>{renderTable()}</Box>
                    </Grid>
                </Grid>
            </Box>
            {renderAddNewUserPopup()}
            {message.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={message.isErrorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {message.successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={message.successMsgText}
                    msgPop={msgClose}
                />
                : null}
            <Loader loaderOpen={postLoad} />
        </Box>
    )
}

export default NurseLogin